import React from "react";
import { Grid, Layout } from "antd";
import { Outlet, useLocation } from "react-router-dom";
import MainNav from "../Navbars/MainNav";
import Sidebar from "../Navbars/Sidebar";

const { Content } = Layout;
const { useBreakpoint } = Grid;

const AdminLayout = () => {
  const location = useLocation();

  const selectedKey = location.pathname;
  const screens = useBreakpoint();
  const marginLeft = screens.lg ? 200 : 0;
  const padding = screens.lg ? "20px" : 0;
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <MainNav />

      <Layout>
        <Sidebar selectedKey={selectedKey} />

        <Layout
          style={{
            marginLeft: marginLeft,
            padding: padding,
          }}
        >
          <Content
            style={{
              margin: "0",
              minHeight: "100%",
            }}
          >
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
